module.exports = __webpack_public_path__ + "media/colleges/tell-your-friends-about-fastweb-6782f273.png";